import styled from '@emotion/styled';

export const Container = styled.div`
    h2 {
        margin-bottom: 5px;
    }

    button {
        margin-top: 24px;
    }
`;
